<style lang="scss">
    @import "@/assets/scss/vuexy/pages/Config.scss";
</style>

<template>
   <div class="item-grid-view vx-row match-height mt-4 edit-information-view">
        <div class="vx-col w-full">
          <vs-button :to="`/labels/detail/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
        </div>
        <div class="lg:w-1/3 sm:w-1/2 w-full">
            <div class="w-full grid-view-item">
            <vx-card class=" mb-base overflow-hidden">
                <div class="inline-block">
                    <img alt="" class="grid-avatar-img" src="@/assets/images/icons/label.svg"/>
                </div>
                <div class="">
                    <div class="w-full text-xl">
                        <span class="font-bold">{{$t('Labels.Alias')}}</span>
                        <span class="main-info colored-info">
                            <vs-input class="w-full" type="text" v-model="response.alias_label"/>
                        </span>
                    </div>
                    <div class="text-center text-3xl mt-3">{{$t("Labels.ReportTime")}}</div>
                    <vs-divider/>
                    <timeConfig v-if="response.time !== undefined" v-on:time="onTimeChange" v-on:unity="onUnityChange" :time="response.time !== ''? parseInt(response.time): 0" :unity="response.time_unity"/>
                </div>
                <div class="submit-button-container mt-5 text-right">
                  <vs-button @click="formSubmit" class="submit-button" >
                    {{$t('Labels.Save')}}
                  </vs-button>
                </div>
            </vx-card>
            </div>
        </div>

        <div class="vx-col lg:w-2/3 sm:w-2/3 w-full ">
            <vx-card class="grid-view-item mb-base overflow-hidden address-card">
                <div class="avatar-info-container">
                    <span class="account-number">
                        {{$t('Labels.DeviceLocation')}}
                    </span>
                    <div class="map-container">
                        <l-map :center="center" :zoom="zoom" v-if="response">
                            <l-tile-layer :attribution="attribution" :url="url">
                            </l-tile-layer>
                            <l-marker :draggable="draggable" :lat-lng="marker" ref="position_marker">
                                <l-icon :icon-anchor="[12, 27]" >
                                  <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                              </l-icon>
                            </l-marker>
                        </l-map>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import { request } from '@/request.js'
import timeConfig from '@/components/timeConfig/timeConfig.vue'
/* global L:true */

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    timeConfig
  },
  data () {
    return {
      zoom: 18,
      url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png',
      attribution: '',
      draggable: true,
      response: [],
      tileProviders,
      layersPosition: 'topright',
      center: L.latLng(47.41322, -1.219482),
      marker: L.latLng(47.41322, -1.219482),
      status_mapa: false,
      urlImg: 'https://leafletjs.com/examples/crs-simple/uqm_map_full.png',
      bounds: [[-26.5, -25], [1021.5, 1023]],
      staticAnchor: [12, 27],
      time: 0,
      time_unity: '',
      uuid: this.$route.params.uuid
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const params = {
        url: `modelo/labels/${this.$route.params.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data
        const [lat, lng] = this.response.location_label.split(',')
        this.marker = L.latLng(lat, lng)
        this.center = L.latLng(lat, lng)
        this.status_mapa = true
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    async formSubmit (e) {
      e.preventDefault()
      this.$vs.loading()
      this.response.location = this.$refs.position_marker.latLng.lat + ',' + this.$refs.position_marker.latLng.lng
      const params = {
        url: `modelo/labels/${this.$route.params.uuid}`,
        method: 'PUT',
        params: this.response
      }
      await request(params).finally(() => {
        this.$vs.loading.close()
      })
    },
    onTimeChange (value) {
      this.response.time = value
    },
    onUnityChange (value) {
      this.response.time_unity = value
    }
  },
  created () {
    this.getResponse()
  }
}
</script>

<!--<style scoped>
  .vue2leaflet-map >>> .leaflet-shadow-pane {
    display: none !important;
  }
</style>-->
